import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { SlidersHorizontal } from "lucide-react";
import { Button } from "../components/ui/Button";
import RequestQuotationModal from "./RequestQuotationModal";
import products from "../data/products";


const FilterModal = ({ isOpen, onClose, onSelect }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black/50 z-50">
      <div className="bg-[#FBF1EB] p-3 rounded-md w-full sm:w-3/4 md:w-1/3 lg:w-1/4 shadow-lg">
        <h2 className="text-lg font-bold mb-4">Category</h2>
        <ul className="space-y-2">
          {["Dehydrated Products", "Turmeric Powder", "Chilly Powder"].map(
            (category) => (
              <li
                key={category}
                className="py-2 cursor-pointer border-b border-gray-300 text-[#753611] hover:bg-[#814726] hover:text-white px-5 transition duration-200"
                onClick={() => {
                  onSelect(category);
                  onClose();
                }}
              >
                {category}
              </li>
            )
          )}
        </ul>

        <div className="flex justify-between mt-4">
          <Button
            variant="outline"
            className="w-40"
            onClick={() => {
              onSelect(null);
              onClose();
            }}
          >
            Clear Filter
          </Button>
          <Button className="w-40" onClick={onClose}>
            Close
          </Button>
        </div>
      </div>
    </div>
  );
};

export default function Collection() {
  const navigate = useNavigate();
  const [isQuotationModalOpen, setIsQuotationModalOpen] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [selectedFilter, setSelectedFilter] = useState(null);
  const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);

  const openQuotationModal = (product) => {
    setSelectedProduct(product);
    setIsQuotationModalOpen(true);
  };

  const closeQuotationModal = () => setIsQuotationModalOpen(false);

  const navigateToProductDetail = (product) => {
    navigate(`/products/${product.id}`);
  };

  const filteredProducts = selectedFilter
    ? products.filter((product) => product.category === selectedFilter)
    : products;

  return (
    <div className="min-h-screen bg-[#FFF3D6]">
      {/* Collection Grid */}
      <section className="w-full py-12 px-4 md:px-8 bg-[#FFF3D6]">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="inline-block text-2xl md:text-2xl font-bold text-white bg-[#8b5e3c] px-8 py-3 shadow-lg">
             SPECIALIZED PRODUCTS
            </h2>
          </div>

          <div className="flex justify-between items-center mb-8">
            <div></div>
            <button
              className="text-[#4EB527]"
              onClick={() => setIsFilterModalOpen(true)}
            >
              <SlidersHorizontal size={24} />
            </button>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
            {filteredProducts.map((product) => (
              <div key={product.id} className="flex flex-col items-center">
                <div
                  className="w-full aspect-square relative mb-2 cursor-pointer group"
                  onClick={() => navigateToProductDetail(product)}
                >
                  <div className="absolute inset-0 flex items-center justify-center">
                    <img
                      src={product.image}
                      alt={product.name}
                      className="max-w-full max-h-full object-contain border-4 border-[#8F5D3F] rounded-lg group-hover:scale-105 transition-transform duration-300"
                    />
                  </div>
                </div>
                <h3 className="text-lg font-medium text-[#34302B] mb-2 text-center">
                  {product.name}
                </h3>
                <Button
                  className="bg-[#8b5e3c] hover:bg-[#8b5e3c] text-white text-sm"
                  onClick={(e) => {
                    e.stopPropagation();
                    navigate(`/products/${product.id}`);
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                  }}
                >
                  View Details
                </Button>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Modals */}
      <RequestQuotationModal
        isOpen={isQuotationModalOpen}
        onClose={closeQuotationModal}
        productName={selectedProduct?.name || ""}
        productId={selectedProduct?.id || ""}
      />

      <FilterModal
        isOpen={isFilterModalOpen}
        onClose={() => setIsFilterModalOpen(false)}
        onSelect={setSelectedFilter}
      />
    </div>
  );
}
